import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

export interface DetailsItemProps {
  label: string;
  value: string | React.ReactNode;
}

export interface TicketApplicationBaseInfoProps {
  title: string;
  orderDetails?: DetailsItemProps[];
}

export interface LegacyApplicationSuccessDetailsProps extends TicketApplicationBaseInfoProps {
  onClose: () => void;
  onFollow: () => void;
  disabledFollow?: boolean;
}
export const LegacyApplicationSuccessDetails: React.FC<LegacyApplicationSuccessDetailsProps> = ({
  onClose,
  onFollow,
  disabledFollow,
  orderDetails,
  title,
}) => {
  const renderInfo = (info: DetailsItemProps) => {
    const isValueString = typeof info.value === 'string';

    return (
      <HStack justifyContent="space-between" space={Spacing['inline.quarck']}>
        <UI.Text>{info.label}</UI.Text>
        {isValueString ? (
          <UI.Text maxW={{ base: '200px', sm: '2/3' }} variant="semibold" textAlign="right">
            {info.value}
          </UI.Text>
        ) : (
          info.value
        )}
      </HStack>
    );
  };

  return (
    <VStack space={Spacing['stack.xs']}>
      <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
        <VStack p={Spacing['inset.sm']} space={Spacing['stack.xxxs']}>
          <VStack space="stack.xxxs" alignItems="center" alignSelf="center" w="full">
            <UI.Icon name="Success" size="xl" color="feedback.success.default" />
            <UI.Text variant="semibold" textAlign="center" fontSize="lg">
              {title}
            </UI.Text>
          </VStack>

          {orderDetails && (
            <VStack
              borderRadius={BoxBorder.heavy}
              px={Spacing['inline.xxs']}
              py={Spacing['stack.xxxs']}
              space={Spacing['stack.nano']}
              bg={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}>
              {orderDetails.map((item) => (
                <Stack key={item.label} w="full">
                  {renderInfo(item)}
                </Stack>
              ))}
            </VStack>
          )}
        </VStack>
      </UI.Shadow>

      <Stack
        direction={Utils.Responsive.TabletDesktop({ tablet: 'column', desktop: 'row' })}
        justifyContent="space-between"
        space={Spacing['inline.xxxs']}>
        <UI.Button flex={1} variant="secondary" isDisabled={disabledFollow} onPress={onFollow}>
          Acompanhar
        </UI.Button>
        <UI.Button flex={1} variant="primary" onPress={onClose}>
          Nova boleta
        </UI.Button>
      </Stack>
    </VStack>
  );
};
